import StaffEnabled from './components/Enabled';
import StaffDisabled from './components/Disabled';
const StaffPage = {
	StaffEnabled,
	StaffDisabled,
};

export { StaffPage };
